export default __webpack_public_path__ + "static/media/fundraiseSupport.e8f415cc.png";